// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSessionModel {
    static getAttributeTypeMap() {
        return AccountSessionModel.attributeTypeMap;
    }
}
AccountSessionModel.discriminator = undefined;
AccountSessionModel.attributeTypeMap = [
    {
        "name": "sessionId",
        "baseName": "sessionId",
        "type": "number"
    },
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "sessionDate",
        "baseName": "sessionDate",
        "type": "Date"
    },
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "entityId",
        "baseName": "entityId",
        "type": "number"
    }
];
//# sourceMappingURL=accountSessionModel.js.map